(() => {
  'use strict';
  const host = document.querySelector('[data-bca-discovery]');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const root = host.dataset.root || '/', currency = host.dataset.currency || 'COP';
  const prefix = 'bca-discovery-v1:' + host.dataset.store + ':';
  const dialog = document.querySelector('#bca-favorites');
  const currentElement = document.querySelector('[data-bca-current-product]');
  const TTL = 30 * 86400000;
  const cache = new Map();
  let favorites = read('favorites', 60), recent = historyAllowed() ? read('recent', 12) : [];
  let returnFocus, toastTimer, dialogRevision = 0, recentRevision = 0, blanketRevision = 0;
  function safeUrl(value, image = false) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (image) return url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopify.com')) ? url.href : '';
      return url.origin === location.origin && url.pathname.includes('/products/') ? url.pathname : '';
    } catch (_) { return ''; }
  }
  function normalize(item) {
    if (!item || typeof item.handle !== 'string' || !/^[a-z0-9-]{1,200}$/.test(item.handle)) return null;
    const url = safeUrl(item.url || root + 'products/' + item.handle);
    if (!url) return null;
    return {handle: item.handle, title: String(item.title || 'Producto Bacanime').slice(0,240), image: safeUrl(item.image || '', true), url, at: Number(item.at) || Date.now()};
  }
  function read(key, limit) {
    try {
      const data = JSON.parse(localStorage.getItem(prefix + key) || '[]');
      if (!Array.isArray(data)) return [];
      const seen = new Set();
      return data.map(normalize).filter(item => item && item.at > Date.now() - TTL && item.at <= Date.now() + 60000 && !seen.has(item.handle) && seen.add(item.handle)).slice(0,limit);
    } catch (_) { return []; }
  }
  function write(key, items) {
    try { localStorage.setItem(prefix + key, JSON.stringify(items)); return true; } catch (_) { return false; }
  }
  function historyAllowed() {
    try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; } catch (_) { return false; }
  }
  function emit(action, item, placement) {
    const payload = {action, handle: item?.handle || '', placement: placement || 'discovery', version: '1'};
    document.dispatchEvent(new CustomEvent('bca:discovery', {detail: payload}));
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
        Promise.resolve(window.Shopify.analytics?.publish('bacanime:discovery_interaction', payload)).catch(() => {});
      }
    } catch (_) { /* Analytics never blocks shopping. */ }
  }
  function notify(message) {
    let toast = document.querySelector('.bca-discovery-toast');
    if (!toast) { toast = document.createElement('div'); toast.className = 'bca-discovery-toast'; toast.setAttribute('role','status'); document.body.append(toast); }
    toast.textContent = message; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 3200);
    const status = dialog?.querySelector('[data-bca-discovery-status]');
    if (status) status.textContent = message;
  }
  function saved(handle) { return favorites.some(item => item.handle === handle); }
  function syncButtons() {
    document.querySelectorAll('[data-bca-save]').forEach(button => {
      const isSaved = saved(button.dataset.handle);
      button.hidden = false;
      const title = button.dataset.title || 'producto';
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute('aria-label', (isSaved ? 'Quitar ' : 'Guardar ') + title + (isSaved ? ' de favoritos' : ' en favoritos'));
      const icon = button.querySelector('[data-bca-save-icon]'), label = button.querySelector('[data-bca-save-label]');
      if (icon && icon.textContent !== (isSaved ? '♥' : '♡')) icon.textContent = isSaved ? '♥' : '♡';
      if (label && label.textContent !== (isSaved ? 'Guardado' : 'Guardar favorito')) label.textContent = isSaved ? 'Guardado' : 'Guardar favorito';
    });
    document.querySelectorAll('[data-bca-favorite-count]').forEach(node => { if (node.textContent !== String(favorites.length)) node.textContent = String(favorites.length); });
  }
  async function live(item) {
    if (!cache.has(item.handle)) cache.set(item.handle, (async () => {
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js', {credentials:'same-origin'});
        if (!response.ok) throw new Error('Unavailable');
        const product = await response.json();
        const fresh = normalize({handle:product.handle, title:product.title, image:product.featured_image, url:root + 'products/' + product.handle});
        if (!fresh) throw new Error('Invalid product');
        return {...fresh, price:product.price_min, available:product.available, kind:product.type, variantId:(product.variants||[]).find(variant=>variant.available)?.id};
      } catch (_) { return {...item, available:null}; }
    })());
    return cache.get(item.handle);
  }
  function card(item, placement) {
    const li = document.createElement('li'); li.className = 'bca-discovery-card card-wrapper product-card-wrapper';
    const link = document.createElement('a'); link.href = item.url;
    link.dataset.bcaDiscoveryLink = ''; link.dataset.placement = placement; link.dataset.handle = item.handle;
    if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy'; img.width = 360; img.height = 450; link.append(img); }
    const title = document.createElement('h3'); title.textContent = item.title; link.append(title);
    const price = document.createElement('p');
    price.textContent = Number.isFinite(item.price) && item.available === true ? 'Desde ' + new Intl.NumberFormat('es-CO', {style:'currency',currency,maximumFractionDigits:0}).format(item.price / 100) + ' ' + currency : item.available === false ? 'Agotado por ahora' : 'Consulta disponibilidad';
    const buyline=document.createElement('div');buyline.className='bca-card-buyline';price.className='bca-card-price';
    if(Number.isFinite(item.price)&&item.available===true){const current=document.createElement('span');current.className='bca-card-price__current';const from=document.createElement('span');from.className='bca-card-price__from';from.textContent='Desde';const amount=document.createElement('span');amount.className='bca-card-price__amount';amount.textContent=new Intl.NumberFormat('es-CO',{style:'currency',currency,maximumFractionDigits:0}).format(item.price/100).replace(/\s/g,'')+' ';const unit=document.createElement('small');unit.textContent=currency;amount.append(unit);current.append(from,' ',amount);price.replaceChildren(current);}
    buyline.append(price);
    const cta=document.createElement('a');cta.className='bca-card-panel-link bca-card-cart-plus';cta.href=item.url;cta.setAttribute('aria-label','Elegir '+item.title);
    cta.innerHTML='<svg aria-hidden="true" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h3l3 12h11l3-9H6M8 15l-1 3h13M12 8v5m-2.5-2.5h5"/><circle cx="9" cy="21" r="1"/><circle cx="18" cy="21" r="1"/></svg>';buyline.append(cta);
    if(item.variantId&&item.available){const group=document.createElement('div');group.hidden=true;group.dataset.kind=/^cobija/i.test(item.kind||item.title)?'blanket':'unit';const source=document.createElement('button');source.type='button';source.hidden=true;source.dataset.bcaCardColorChoice='';source.dataset.url=item.url+'?variant='+item.variantId;source.dataset.image=item.image;source.dataset.productTitle=item.title;source.dataset.color='';group.append(source);li.append(group);}
    const button = document.createElement('button'); button.type = 'button'; button.className = 'bca-save bca-save--compact'; button.dataset.bcaSave = '';
    Object.assign(button.dataset, {handle:item.handle,title:item.title,image:item.image,url:item.url});
    const icon = document.createElement('span'); icon.dataset.bcaSaveIcon = ''; icon.setAttribute('aria-hidden','true'); button.append(icon);
    li.append(link,buyline,button); return li;
  }
  async function cards(items, target, placement) {
    const rendered = [];
    for (let offset = 0; offset < items.length; offset += 4) {
      const batch = await Promise.all(items.slice(offset,offset+4).map(live));
      rendered.push(...batch.map(item => card(item,placement)));
    }
    if (target) { target.replaceChildren(...rendered); syncButtons(); }
    return rendered;
  }
  async function showFavorites() {
    const revision = ++dialogRevision;
    const empty = dialog.querySelector('[data-bca-favorites-empty]');
    empty.hidden = favorites.length > 0;
    const grid = dialog.querySelector('[data-bca-favorites-grid]');
    grid.setAttribute('aria-busy','true');
    const nodes = await cards(favorites, null, 'favorites');
    if (revision === dialogRevision) { grid.replaceChildren(...nodes); grid.removeAttribute('aria-busy'); syncButtons(); }
  }
  async function showRecent() {
    const revision = ++recentRevision;
    const shelf = document.querySelector('[data-bca-recent]');
    const list = recent.filter(item => item.handle !== currentElement?.dataset.handle).slice(0,6);
    if (shelf) {
      shelf.hidden = !list.length;
      const nodes = await cards(list,null,'recent');
      if (revision !== recentRevision) return;
      shelf.querySelector('[data-bca-recent-grid]').replaceChildren(...nodes); syncButtons();
    }
    const shortcut = document.querySelector('[data-bca-recent-shortcut]'); if (shortcut) shortcut.hidden = !list.length;
  }
  async function showBlankets() {
    const revision = ++blanketRevision;
    const shelf = document.querySelector('[data-bca-for-you]'); if (!shelf) return;
    if (!recent.length) { shelf.hidden = true; return; }
    let items = [], matched = false;
    if (recent[0]) {
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(recent[0].handle) + '?view=bca-discovery', {credentials:'same-origin'});
        if (response.ok) { const data = JSON.parse(await response.text()); items = (data.products || []).map(normalize).filter(Boolean); matched = !!items.length; }
      } catch (_) { /* Keep real catalog alternatives as a fallback. */ }
    }
    if (!items.length) items = ['cobija-dragon-ball-nimor','cobija-iron-maiden-nimor','cobija-sailor-moon-nimor','cobija-pokemon-nimor'].map(handle => normalize({handle,url:root+'products/'+handle}));
    const products = (await Promise.all(items.map(live))).filter(item => item.available === true && /^cobija/i.test(item.kind || item.title)).slice(0,4);
    if (revision !== blanketRevision) return;
    shelf.querySelector('[data-bca-for-you-title]').textContent = matched ? 'Tu fandom también abriga' : 'Cobijas para tu próxima maratón';
    shelf.querySelector('[data-bca-for-you-copy]').textContent = matched ? 'Cobijas de una temática que acabas de explorar.' : 'Ideas para tu próxima maratón de series, anime o música.';
    const grid = shelf.querySelector('[data-bca-for-you-grid]'); grid.replaceChildren(...products.map(item => card(item,'home-blankets')));
    const entry = document.querySelector('.bca-arcade')?.closest('.shopify-section');
    if (entry) entry.after(shelf);
    shelf.hidden = !products.length; syncButtons();
  }
  function recordCurrent() {
    if (!currentElement) return;
    const item = normalize(currentElement.dataset); if (!item) return;
    recent = [item,...recent.filter(old => old.handle !== item.handle)].slice(0,12);
    if (historyAllowed()) write('recent',recent);
  }
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-bca-save]');
    if (save) {
      event.preventDefault(); event.stopPropagation();
      const item = normalize(save.dataset); if (!item) return;
      const removing = saved(item.handle);
      if (!removing && favorites.length >= 60) { notify('Ya tienes 60 favoritos. Quita uno para guardar otro.'); return; }
      favorites = removing ? favorites.filter(old => old.handle !== item.handle) : [item,...favorites];
      const persisted = write('favorites', favorites);
      syncButtons(); if (dialog?.open) showFavorites();
      notify(removing ? 'Quitado de tus favoritos' : persisted ? 'Guardado en tus favoritos' : 'Guardado durante esta visita; tu navegador no permite conservarlo.');
      emit(removing ? 'favorite_remove' : 'favorite_add',item,save.closest('.bca-favorites') ? 'favorites' : 'product-card'); return;
    }
    if (event.target.closest('[data-bca-open-favorites]')) {
      returnFocus = event.target.closest('button'); dialog.showModal(); showFavorites(); emit('favorites_open'); return;
    }
    if (event.target.closest('[data-bca-close-favorites]')) { dialog.close(); return; }
    if (event.target.closest('[data-bca-enable-recent]')) {
      const button = event.target.closest('[data-bca-enable-recent]');
      if (!window.Shopify?.customerPrivacy?.setTrackingConsent) { notify('No se pudo activar. Puedes intentarlo de nuevo más tarde.'); return; }
      button.disabled = true;
      window.Shopify.customerPrivacy.setTrackingConsent({preferences:true},() => {
        button.disabled = false; startHistory();
        notify(historyAllowed() ? 'Recordaremos tus productos vistos en este navegador' : 'No se pudo activar el historial en este navegador.');
      });
      return;
    }
    if (event.target.closest('[data-bca-clear-recent]')) {
      recent = []; try { localStorage.removeItem(prefix+'recent'); } catch (_) {}
      showRecent(); showBlankets(); notify('Historial borrado'); emit('recent_clear'); return;
    }
    const link = event.target.closest('[data-bca-discovery-link],#bca-combo-panel a[href],.bca-combo-teaser');
    if (link) {
      const match = link.getAttribute('href')?.match(/\/products\/([^?/#]+)/);
      emit('recommendation_click',{handle:link.dataset.handle || match?.[1] || ''},link.dataset.placement || 'product-combo');
    }
  });
  dialog?.addEventListener('close',() => returnFocus?.focus());
  document.addEventListener('bca:search-type',event => emit('search_type_filter',null,event.detail?.type || 'all'));
  window.addEventListener('storage',event => { if (event.key === prefix+'favorites') { favorites = read('favorites',60); syncButtons(); if (dialog?.open) showFavorites(); } });
  document.addEventListener('visitorConsentCollected',() => {
    if (historyAllowed()) { const stored = read('recent',12); recent = [...recent,...stored.filter(item=>!recent.some(old=>old.handle===item.handle))].slice(0,12); recordCurrent(); showRecent(); showBlankets(); }
    else { recent = []; try { localStorage.removeItem(prefix+'recent'); } catch (_) {} showRecent(); showBlankets(); }
  });
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(record => record.addedNodes.length)) return;
    scheduled = true; requestAnimationFrame(()=>{scheduled=false;syncButtons();});
  }).observe(document.querySelector('#MainContent'),{childList:true,subtree:true});
  function startHistory() {
    host.dataset.historyMode = historyAllowed() ? 'remembered' : 'visit-only';
    host.dataset.privacyReady = String(typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function');
    host.dataset.privacyLoader = String(typeof window.Shopify?.loadFeatures === 'function');
    const enable = document.querySelector('[data-bca-enable-recent]');
    if (enable) enable.hidden = historyAllowed() || !window.Shopify?.customerPrivacy?.setTrackingConsent;
    if (historyAllowed()) recent = read('recent',12);
    recordCurrent(); showRecent(); showBlankets();
  }
  host.hidden = false; syncButtons();
  if (window.Shopify?.customerPrivacy) startHistory();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error => {
      host.dataset.privacyLoadError = error ? String(error.message || error).slice(0,180) : '';
      if (error && String(error.message || error).includes('loaded at version 0.1')) {
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],legacyError => {
          host.dataset.privacyLoadError = legacyError ? String(legacyError.message || legacyError).slice(0,180) : '';
          startHistory();
        });
        return;
      }
      startHistory();
    });
  } else startHistory();
})();
